/** @format */

import $ from "jquery";
import { Space, Switch } from "antd";
import React, { useEffect, useState } from "react";
import { NavLink, Route, Routes, useParams } from "react-router-dom";

import Add from "./Add";
import Oylik from "./Oylik";
import Kunlik from "./Kunlik";
import Yillik from "./Yillik";
import Dekadalik from "./Dekadalik";
import ContentTop from "../../../../components/ContentTop";
import { user_data } from "../../../../components/functions/usr";

// import Add2 from "./Add2";

function AsosiyManbalar(props) {
  const params = useParams();
  const [menu, setMenu] = useState(0);
  const [date, setDate] = useState("");
  const [havza, setHavza] = useState(1);
  const [vaqt, setVaqt] = useState("ertalabki");
  const region = JSON.parse(localStorage.getItem("sw_user")).fio;

  const selectVaqt = (e) => {
    if (e) {
      setVaqt("ertalabki");
    } else {
      setVaqt("ortacha");
    }
  };

  useEffect(() => {
    switch (params["*"]) {
      case "":
        setMenu(0);
        break;
      case "dekadalik":
        setMenu(1);
        break;
      case "oylik":
        setMenu(2);
        break;
      case "yillik":
        setMenu(3);
        break;
      default:
        break;
    }
  }, []);

  const search = (text) => {
    $("tbody tr.tr").each(function () {
      if (
        $(this)
          .children(".fix-with")[0]
          .innerText.toUpperCase()
          .indexOf(text.toUpperCase()) > -1
      ) {
        $(this)[0].style.display = "";
      } else {
        $(this)[0].style.display = "none";
      }
    });
  };

  return (
    <div className='asosiy_manbalar'>
      <ContentTop>
        <ul className='content-top-left'>
          <li>Asosiy manbalar</li>

          <li></li>

          <li className='ps-4' style={{ scale: "1.4" }}>
            <Space direction='vertical'>
              <Switch
                checkedChildren='Ertalabki'
                unCheckedChildren="O'rtacha"
                defaultChecked
                onChange={(e) => selectVaqt(e)}
              />
            </Space>
          </li>
        </ul>

        <ul className='content-top-right menu'>
          <li>
            <button
              className={menu === 0 ? "active" : ""}
              onClick={() => setMenu(0)}>
              <NavLink to='/asosiymanbalar/'>Kunlik</NavLink>
            </button>
          </li>

          {/*<li>*/}
          {/*  <button*/}
          {/*    className={menu === 1 ? "active" : ""}*/}
          {/*    onClick={() => setMenu(1)}>*/}
          {/*    <NavLink to='/asosiymanbalar/dekada'>10 kunlik</NavLink>*/}
          {/*  </button>*/}
          {/*</li>*/}

          {/*<li>*/}
          {/*  <button*/}
          {/*    className={menu === 2 ? "active" : ""}*/}
          {/*    onClick={() => setMenu(2)}>*/}
          {/*    <NavLink to='/asosiymanbalar/oylik'>Oylik</NavLink>*/}
          {/*  </button>*/}
          {/*</li>*/}

          {/*<li>*/}
          {/*  <button*/}
          {/*    className={menu === 3 ? "active" : ""}*/}
          {/*    onClick={() => setMenu(3)}>*/}
          {/*    <NavLink to='/asosiymanbalar/yillik'>Yillik</NavLink>*/}
          {/*  </button>*/}
          {/*</li>*/}
        </ul>
      </ContentTop>

      <Routes>
        <Route
          path='/'
          element={
            <Kunlik
              region={region}
              vaqt={vaqt}
              search={search}
              setDate={setDate}
              havza={havza}
            />
          }
        />
        {/*<Route*/}
        {/*  path='/dekada'*/}
        {/*  element={*/}
        {/*    <Dekadalik*/}
        {/*      region={region}*/}
        {/*      vaqt={vaqt}*/}
        {/*      search={search}*/}
        {/*      havza={havza}*/}
        {/*    />*/}
        {/*  }*/}
        {/*/>*/}
        {/*<Route*/}
        {/*  path='/oylik'*/}
        {/*  element={*/}
        {/*    <Oylik region={region} vaqt={vaqt} search={search} havza={havza} />*/}
        {/*  }*/}
        {/*/>*/}
        {/*<Route*/}
        {/*  path='/yillik'*/}
        {/*  element={*/}
        {/*    <Yillik region={region} vaqt={vaqt} search={search} havza={havza} />*/}
        {/*  }*/}
        {/*/>*/}
        <Route
          path='/add'
          element={
            <Add vaqt={vaqt} date={date} setDate={setDate} havza={havza} />
          }
        />
      </Routes>
    </div>
  );
}

export default AsosiyManbalar;
